import React from "react";
import styles from "./social-share.module.css";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import { cn } from "../lib/helpers";

import shareFacebookIcon from "../images/Capacity_Share_Facebook.svg";
import shareEmailIcon from "../images/Capacity_Share_Mail.svg";
import shareLinkedInIcon from "../images/Capacity_Share_LinkedIn.svg";
import shareTwitterIcon from "../images/Capacity_Share_Twitter.svg";

const SocialShare = (props) => {
  const pageTitle = typeof window !== `undefined` ? document.title : null;
  const pageUrl = typeof window !== `undefined` ? window.location.href : null;

  return (
    <div className={styles.root}>
      <div className={styles.links}>
        <LinkedinShareButton url={pageUrl}>
          <img
            src={shareLinkedInIcon}
            alt="Share to LinkedIn"
            className={cn(styles.linkedInIcon, styles.socialIcon)}
          />
        </LinkedinShareButton>
        <TwitterShareButton url={pageUrl} title={pageTitle}>
          <img
            src={shareTwitterIcon}
            alt="Share to X"
            className={cn(styles.twitterIcon, styles.socialIcon)}
          />
        </TwitterShareButton>
        <EmailShareButton url={pageUrl} subject={pageTitle}>
          <img
            src={shareEmailIcon}
            alt="Share to Email"
            className={cn(styles.emailIcon, styles.socialIcon)}
          />
        </EmailShareButton>
        <FacebookShareButton url={pageUrl} quote={pageTitle}>
          <img
            src={shareFacebookIcon}
            alt="Share to Facebook"
            className={cn(styles.facebookIcon, styles.socialIcon)}
          />
        </FacebookShareButton>
      </div>
      <div className={styles.shareLabel}>Share</div>
    </div>
  );
};

SocialShare.propTypes = {};

export default SocialShare;
